<template>
  <div v-if="isAttendantUnavailable" class="chat-plan-locked-page">
    <PlanFeatureLocked
      class="chat-plan-locked-panel"
      title="Conversas indisponiveis no seu plano atual"
      message="O modulo de conversas depende do atendimento automatico. Troque de plano para liberar o chatbot e acompanhar os atendimentos por aqui."
    />
  </div>
  <ChatContent v-else />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

import PlanFeatureLocked from "../../components/Common/PlanFeatureLocked.vue";
import ChatContent from "../../components/Chat/ChatContent.vue";

export default defineComponent({
  name: "ChatPage",
  components: {
    PlanFeatureLocked,
    ChatContent,
  },
  computed: {
    ...mapGetters([
      "getConfigurations",
    ]),
    isAttendantUnavailable(): boolean {
      const attendantType = this.getConfigurations?.type_of_attendant;
      return attendantType === 0 || attendantType === "0";
    },
  },
});
</script>

<style scoped>
.chat-plan-locked-page {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: 28px;
  width: 100%;
}

.chat-plan-locked-panel {
  box-shadow: 0 10px 35px rgba(13, 12, 29, 0.08);
  max-width: 620px;
  min-height: 0;
}

@media (max-width: 767px) {
  .chat-plan-locked-page {
    min-height: calc(100vh - 96px);
    padding: 18px;
  }
}
</style>
